// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Radio-module__root--n6qb3 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #1a1a1a;
  cursor: pointer;
}

.Radio-module__input--B6HTm {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}

.Radio-module__indicator--Ektu7 {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  border: 1px solid #bdb7ae;
  border-radius: 50%;
  background-color: #fff;
}

.Radio-module__input--B6HTm:checked + .Radio-module__indicator--Ektu7 {
  border-color: #1a1a1a;
}

.Radio-module__input--B6HTm:checked + .Radio-module__indicator--Ektu7::after {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #1a1a1a;
  content: '';
}

.Radio-module__input--B6HTm:focus-visible + .Radio-module__indicator--Ektu7 {
  outline: 2px solid #1a1a1a;
  outline-offset: 2px;
}

.Radio-module__root--n6qb3:has(.Radio-module__input--B6HTm:disabled) {
  cursor: not-allowed;
  opacity: 0.45;
}

.Radio-module__label--F01A6 {
  font: inherit;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Radio/Radio.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #1a1a1a;\n  cursor: pointer;\n}\n\n.input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.indicator {\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #bdb7ae;\n  border-radius: 50%;\n  background-color: #fff;\n}\n\n.input:checked + .indicator {\n  border-color: #1a1a1a;\n}\n\n.input:checked + .indicator::after {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #1a1a1a;\n  content: '';\n}\n\n.input:focus-visible + .indicator {\n  outline: 2px solid #1a1a1a;\n  outline-offset: 2px;\n}\n\n.root:has(.input:disabled) {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.label {\n  font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Radio-module__root--n6qb3`,
	"input": `Radio-module__input--B6HTm`,
	"indicator": `Radio-module__indicator--Ektu7`,
	"label": `Radio-module__label--F01A6`
};
export default ___CSS_LOADER_EXPORT___;
